<template>
  <div ref="tableContainer" class="table-container">
    <div ref="headerBack" class="header-back"></div>
    <table>
      <thead ref="tableHead">
        <th>年份</th>
        <th v-for="c in tableColumns" :key="c">
          {{ tableColumnsTitle[c]}}
		  <img v-if="columnClickables[c]"
		    :src="mapPng"
		    alt="點選看地圖"
		    :data-column="c"
		    @click="changeCol"
		  />
	    </th>
		<!-- Multiple user columns -->
		<th v-for="(userCol, index) in userColumns" :key="'user-' + index">
		  <input v-model="userCol.title" placeholder="欄位名稱" class="column-title-input" />
		  <img 
		    :src="rmPng"
			alt="移除欄位"
			@click="rmCol(index)"
		  />
		</th>
		<th v-if="applyUserData">
		  <img
		    :src="addPng"
		    alt="新增資料"
		    @click="addCol"
		  />
		</th>
		<th>
		</th>
      </thead>
      <tbody>
        <tr v-for="(y, index) in years" :key="y" :class="{ lastYear: index == (years.length - 1)}">
          <td class="td-year">{{ y }}</td>
          <td v-for="c in tableColumns" :key="c">
            {{ tableData[index][c] }}
          </td>

		  <!-- User data input cells -->
		  <td v-for="(userCol, colIndex) in userColumns" :key="'user-data-' + colIndex" class="user-column">
		  <input 
		 	 v-model="userCol.data[index]" 
		 	 type="number" 
		 	 placeholder="數值" 
		 	 class="data-input"
		 	 @paste="handlePaste($event, colIndex, index)"
		  />
		  </td>
		  <td v-if="applyUserData">
		  </td>
		  <td>
		  </td>
        </tr>

		<tr>
		</tr>
      </tbody>
    </table>

  </div>
</template>

<script>
import mapPng from "../../assets/images/6-analysis/map.png";
import addPng from "../../assets/images/6-analysis/add.png";
import rmPng from "../../assets/images/6-analysis/rm.png";

export default {
  props: [ "tableColumns", "tableColumnsTitle", "columnClickables", "years", "categ", "subcateg", "location", "tableData", "applyUserData", "userColumnsData" ],
  mounted() {
    // this.$refs.headerBack.style.height = this.$refs.tableHead.offsetHeight + "px"
	//var columnTitles = new Array(this.tableColumns.length+1);
	//console.log(this.tableColumns);
	//console.log(this.tableColumnsTitle);
	//console.log(this.tableData);

	// Initialize userColumns from parent's userColumnsData if it exists
	if (this.userColumnsData && this.userColumnsData.length > 0) {
		this.userColumns = [...this.userColumnsData];
	}
    // Scroll to show add button on first visit
	if (this.applyUserData) {
		this.$nextTick(() => {
		const container = this.$refs.tableContainer;
		if (container) {
			container.scrollLeft = container.scrollWidth - container.clientWidth;
		}
		});
	}
  },
  data() {
	return {
	  mapPng,
	  addPng,
	  rmPng,
	  userColumns: []
	}
  },
  methods: {
    runSerial(tasks) {
      var result = Promise.resolve();
      tasks.forEach(task => {
        result = result.then(() => task());
      });
      return result;
    },
    changeCol(e) {
	  var titlePrefix = this.tableColumnsTitle[e.target.dataset.column];
	  var titleSuffix = this.lastYear+'年';
	  var legendTitle = titlePrefix+'（'+titleSuffix+'）'
      let tasks = [
        () => { $('#categ1').val(this.categ.id).change() },
        () => { $('#categ2').val(this.subcateg.id).change() },
        () => { $('#year').val(this.lastYear).change() },
        () => { $('#legendtitle').val(legendTitle).change() },
        () => { $('#categ3').val(e.target.dataset.column).change() },
		() => { this.$root.$emit('retract_panel') }
      ]
      this.runSerial(tasks)
    },
    addCol() {
      const newColumn = {
        title: '',
        data: new Array(this.years.length).fill(null)
      };
      this.userColumns.push(newColumn);
    },
    rmCol(index) {
      this.userColumns.splice(index, 1);
    },
    handlePaste(event, colIndex, rowIndex) {
      event.preventDefault();
      const paste = (event.clipboardData || window.clipboardData).getData('text');
      
      // Split pasted content by tabs (Excel columns) and newlines (Excel rows)
      const rows = paste.split('\n').filter(row => row.trim() !== '');
      const firstRow = rows[0].split('\t');
      
      // If pasting multiple columns, create new user columns as needed
      for (let i = firstRow.length - 1; i > 0; i--) {
        if (colIndex + i >= this.userColumns.length) {
          this.addCol(); // Add new columns if needed
        }
      }
      
      // Fill in the data
      rows.forEach((row, rIdx) => {
        const cols = row.split('\t');
        cols.forEach((cellValue, cIdx) => {
          const targetRowIndex = rowIndex + rIdx;
          const targetColIndex = colIndex + cIdx;
          
          // Make sure we don't go beyond available rows or columns
          if (targetRowIndex < this.years.length && targetColIndex < this.userColumns.length) {
            this.userColumns[targetColIndex].data[targetRowIndex] = parseFloat(cellValue) || cellValue;
          }
        });
      });
	  // Force Vue to update the display
	  this.$forceUpdate();
	  this.$nextTick(() => {
	 	 this.$forceUpdate();
	  });
    }
  },
  watch: {
    userColumns: {
      handler(newVal) {
        const validColumns = newVal.filter(col => col.title.trim() !== '');
        this.$emit('user-columns-changed', validColumns);
      },
      deep: true
    }
  },
  computed: {
    lastYear() {
      return this.years[this.years.length-1]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../css/custom_var";
@import "../../css/custom_mixin";

.table-container {
  padding: 0 10px;
  position: relative;
  background-color: $ts-orange-footer;
  display: inline-block;
  width: auto;  // Let container expand
  max-width: 100%;  // Change from min-width to max-width
  overflow-x: auto;  // Add horizontal scrolling

  .header-back {
    width: 100%;
    height: 30px;
    background-color: $ts-orange-3rd;
    position: absolute;
    top: 0;
    left: 0;
  }

  .download-link{
    float: left;
  }
}

table {
  border-collapse: collapse;
  z-index: 5;
  position: relative;
  width: auto;  // Let table expand naturally
  display: table;  // Ensure proper table behavior
}

td, th {
  text-align: center;
  vertical-align: middle;
}

thead {
  background-color: $ts-orange-3rd;
  th {
    height: 30px;
    font-weight: normal;
    padding: 0 10px;
  }
}

tbody {
  background-color: $ts-orange-footer;
}

tr {
  height: 40px;
  border-bottom: 0.25pt solid #000;

  td {
    padding: 0 10px;
  }

  .td-location {
    min-width: 180px;
    text-align: center;
  }
}

.td-year, tr.lastRow {
  border-bottom: 0.75pt solid #000;
}

tr:nth-last-child(1), tr:nth-last-child(1) td, .lastYear {
  border: none !important;
}

tr.lastYear {
  td {
    border-bottom: 0.25pt solid #000;
  }
}

.column-title-input {
  width: 80px;
  min-width: 80px;  // Add minimum width
  padding: 2px;
  border: 1px solid #ccc;
  border-radius: 3px;
  font-family: inherit;  // Use same font as parent table
  font-size: inherit;    // Use same font size as table cells
  font-weight: inherit;  // Use same font weight
  text-align: center;    // Match table cell alignment
}
.data-input {
  width: 80px;
  min-width: 80px;
  padding: 2px;
  border: 1px solid #ccc;
  border-radius: 3px;
  font-family: inherit;  // Use same font as parent table
  font-size: inherit;    // Use same font size as table cells
  font-weight: inherit;  // Use same font weight
  text-align: center;    // Match table cell alignment
  
  // Remove number input spinners/arrows
  -moz-appearance: textfield;
  
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}

</style>
